import { render } from "./ReservationComponent.vue?vue&type=template&id=79124f78&scoped=true"
import script from "./ReservationComponent.vue?vue&type=script&lang=js"
export * from "./ReservationComponent.vue?vue&type=script&lang=js"

import "./ReservationComponent.vue?vue&type=style&index=0&id=79124f78&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79124f78"]])

export default __exports__